import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-cambio-estado-ondemand',
  templateUrl: './modal-cambio-estado-ondemand.component.html',
  styleUrls: ['./modal-cambio-estado-ondemand.component.css']
})
export class ModalCambioEstadoOndemandComponent {
  doctorTemporal: any; // ✅ Clon del doctor para evitar modificarlo directamente

  constructor(
    public dialogRef: MatDialogRef<ModalCambioEstadoOndemandComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // ✅ Clonar el objeto doctorSeleccionado para evitar modificaciones inesperadas
    this.doctorTemporal = { ...this.data.doctorSeleccionado };
  }

 
  confirmarCambioEstado() {
    // console.log(this.doctorTemporal, 'doctorTemporal');
    
    this.dialogRef.close({
      confirmed: true,
      doc_id: this.doctorTemporal.doc_id, // ✅ Enviar el ID correcto
      estado: this.data.estadoNuevo,
      conf_by: this.data.usuario._id, // ✅ ID del usuario coordinador
      conf_typ: 2, // ✅ Tipo de confirmación
      agenda_id: this.doctorTemporal.sch_od_id
    });
  }
  

  cancelarCambioEstado() {
    this.dialogRef.close({ confirmed: false });
  }
}
